const HOSPITAL_GENK = -31895;
const GOD_ROLE = "God";
const NO_GROUP = -1;
const REFRESH_SETTINGS = {
    checkWindow: 60000,
    refreshAt: 300000,
};

export { HOSPITAL_GENK, GOD_ROLE, NO_GROUP, REFRESH_SETTINGS };
